@if (sourcing.about) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.about' | translate }}</div>
    <div [innerHTML]="sourcing.about | rtEncodeHTML | rtSimpleFormat" class="value"></div>
  </div>
}

@if (sourcing.website) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.website' | translate }}</div>
    <div class="value">
      <a [href]="sourcing.website" target="_blank">{{ sourcing.website }}</a>
    </div>
  </div>
}

@if (sourcing.location) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.location' | translate }}</div>
    <div class="value">{{ sourcing.location }}</div>
  </div>
}

@if (sourcing.jobTitle) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.job_title' | translate }}</div>
    <div class="value">{{ sourcing.jobTitle }}</div>
  </div>
}

@if (sourcing.worksFor) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.works_for' | translate }}</div>
    <div class="value">{{ sourcing.worksFor }}</div>
  </div>
}

@if (sourcing.roles) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.roles' | translate }}</div>
    <div class="value">{{ sourcing.roles }}</div>
  </div>
}

@if (sourcing.skills) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.skills' | translate }}</div>
    <div class="value">{{ sourcing.skills }}</div>
  </div>
}

@if (sourcing.projectViews) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.project_views' | translate }}</div>
    <div class="value">{{ sourcing.projectViews }}</div>
  </div>
}

@if (sourcing.appreciations) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.appreciations' | translate }}</div>
    <div class="value">{{ sourcing.appreciations }}</div>
  </div>
}

@if (sourcing.followers) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.followers' | translate }}</div>
    <div class="value">{{ sourcing.followers }}</div>
  </div>
}

@if (sourcing.following) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.following' | translate }}</div>
    <div class="value">{{ sourcing.following }}</div>
  </div>
}

@if (sourcing.shots) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.shots' | translate }}</div>
    <div class="value">{{ sourcing.shots }}</div>
  </div>
}

@if (sourcing.likes) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.likes' | translate }}</div>
    <div class="value">{{ sourcing.likes }}</div>
  </div>
}

@if (sourcing.starred) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.starred' | translate }}</div>
    <div class="value">{{ sourcing.starred }}</div>
  </div>
}

@if (sourcing.reputation) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.reputation' | translate }}</div>
    <div class="value">{{ sourcing.reputation }}</div>
  </div>
}

@if (sourcing.answers) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.answers' | translate }}</div>
    <div class="value">{{ sourcing.answers }}</div>
  </div>
}

@if (sourcing.questions) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.source_questions' | translate }}</div>
    <div class="value">{{ sourcing.questions }}</div>
  </div>
}

@if (sourcing.peopleReached) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.people_reached' | translate }}</div>
    <div class="value">{{ sourcing.peopleReached }}</div>
  </div>
}

@if (sourcing.tweets) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.tweets' | translate }}</div>
    <div class="value">{{ sourcing.tweets }}</div>
  </div>
}

@if (sourcing.haves) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.haves' | translate }}</div>
    <div class="value">{{ sourcing.haves }}</div>
  </div>
}

@if (sourcing.wants) {
  <div class="item">
    <div class="value-label">{{ 'app.candidate.wants' | translate }}</div>
    <div class="value">{{ sourcing.wants }}</div>
  </div>
}

@if (sourcing.workHistory && sourcing.workHistory.length > 0) {
  <div class="item experience">
    <div class="value-label">{{ 'app.candidate.experience' | translate }}</div>
    @for (work of sourcing.workHistory; track trackByJsonString($index, work)) {
      <div class="value">
        @if (work.title) {
          <div class="name">{{ work.title }}</div>
        }
        @if (work.company) {
          <div class="company">{{ work.company }}</div>
        }
        @if (work.duration) {
          <div class="duration">{{ work.duration }}</div>
        }
      </div>
    }
  </div>
}

@if (sourcing.educationHistory && sourcing.educationHistory.length > 0) {
  <div class="item education">
    <div class="value-label">{{ 'app.candidate.education' | translate }}</div>
    @for (work of sourcing.educationHistory!; track trackByJsonString($index, work)) {
      <div class="value">
        @if (work.school) {
          <div class="name">{{ work.school }}</div>
        }
        @if (work.degree) {
          <div class="degree">{{ work.degree }}</div>
        }
        @if (work.duration) {
          <div class="duration">{{ work.duration }}</div>
        }
      </div>
    }
  </div>
}
